import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isSome as t } from "./maybe.js";
import e from "./PooledArray.js";
var s = -3;

var i = /*#__PURE__*/function () {
  function i(t, e, s) {
    _classCallCheck(this, i);

    this._namespace = t, this._storage = e, this._removeFunc = !1, this._hit = 0, this._miss = 0, this._storage.register(this), this._namespace += ":", s && (this._storage.registerRemoveFunc(this._namespace, s), this._removeFunc = !0);
  }

  _createClass(i, [{
    key: "destroy",
    value: function destroy() {
      this._storage.clear(this._namespace), this._removeFunc && this._storage.deregisterRemoveFunc(this._namespace), this._storage.deregister(this), this._storage = null;
    }
  }, {
    key: "namespace",
    get: function get() {
      return this._namespace.slice(0, -1);
    }
  }, {
    key: "hitRate",
    get: function get() {
      return this._hit / (this._hit + this._miss);
    }
  }, {
    key: "size",
    get: function get() {
      return this._storage.size;
    }
  }, {
    key: "maxSize",
    get: function get() {
      return this._storage.maxSize;
    }
  }, {
    key: "resetHitRate",
    value: function resetHitRate() {
      this._hit = this._miss = 0;
    }
  }, {
    key: "put",
    value: function put(t, e, s) {
      var _i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

      this._storage.put(this._namespace + t, e, s, _i);
    }
  }, {
    key: "get",
    value: function get(t) {
      var e = this._storage.get(this._namespace + t);

      return void 0 === e ? ++this._miss : ++this._hit, e;
    }
  }, {
    key: "pop",
    value: function pop(t) {
      var e = this._storage.pop(this._namespace + t);

      return void 0 === e ? ++this._miss : ++this._hit, e;
    }
  }, {
    key: "updateSize",
    value: function updateSize(t, e, s) {
      this._storage.updateSize(this._namespace + t, e, s);
    }
  }, {
    key: "clear",
    value: function clear() {
      this._storage.clear(this._namespace);
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this._storage.clearAll();
    }
  }, {
    key: "getStats",
    value: function getStats() {
      return this._storage.getStats();
    }
  }, {
    key: "resetStats",
    value: function resetStats() {
      this._storage.resetStats();
    }
  }]);

  return i;
}();

var h = /*#__PURE__*/function () {
  function h() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10485760;

    _classCallCheck(this, h);

    this._maxSize = t, this._db = new Map(), this._size = 0, this._hit = 0, this._miss = 0, this._removeFuncs = new e(), this._users = new e();
  }

  _createClass(h, [{
    key: "destroy",
    value: function destroy() {
      this.clearAll(), this._removeFuncs.clear(), this._users.clear(), this._db = null;
    }
  }, {
    key: "register",
    value: function register(t) {
      this._users.push(t);
    }
  }, {
    key: "deregister",
    value: function deregister(t) {
      this._users.removeUnordered(t);
    }
  }, {
    key: "registerRemoveFunc",
    value: function registerRemoveFunc(t, e) {
      this._removeFuncs.push([t, e]);
    }
  }, {
    key: "deregisterRemoveFunc",
    value: function deregisterRemoveFunc(t) {
      this._removeFuncs.filterInPlace(function (e) {
        return e[0] !== t;
      });
    }
  }, {
    key: "size",
    get: function get() {
      return this._size;
    }
  }, {
    key: "maxSize",
    get: function get() {
      return this._maxSize;
    },
    set: function set(t) {
      this._maxSize = Math.max(t, 0), this._checkSizeLimit();
    }
  }, {
    key: "put",
    value: function put(t, e, i, _h) {
      var r = this._db.get(t);

      if (r && (this._size -= r.size, this._db.delete(t), r.entry !== e && this._notifyRemove(t, r.entry, 0)), i > this._maxSize) return void this._notifyRemove(t, e, 0);
      if (void 0 === e) return void console.warn("Refusing to cache undefined entry ");
      if (!i || i < 0) return void console.warn("Refusing to cache entry with invalid size " + i);

      var _ = 1 + Math.max(_h, s) - s;

      this._db.set(t, {
        entry: e,
        size: i,
        lifetime: _,
        lives: _
      }), this._size += i, this._checkSizeLimit();
    }
  }, {
    key: "updateSize",
    value: function updateSize(e, s, i) {
      var _h2 = this._db.get(e);

      if (_h2 && _h2.entry === s) {
        for (this._size -= _h2.size; i > this._maxSize;) {
          var _h8 = this._notifyRemove(e, s, 1);

          if (!(t(_h8) && _h8 > 0)) return void this._db.delete(e);
          i = _h8;
        }

        _h2.size = i, this._size += i, this._checkSizeLimit();
      }
    }
  }, {
    key: "pop",
    value: function pop(t) {
      var e = this._db.get(t);

      if (e) return this._size -= e.size, this._db.delete(t), ++this._hit, e.entry;
      ++this._miss;
    }
  }, {
    key: "get",
    value: function get(t) {
      var e = this._db.get(t);

      if (void 0 !== e) return this._db.delete(t), e.lives = e.lifetime, this._db.set(t, e), ++this._hit, e.entry;
      ++this._miss;
    }
  }, {
    key: "getStats",
    value: function getStats() {
      var _this = this;

      var t = {
        Size: Math.round(this._size / 1048576) + "/" + Math.round(this._maxSize / 1048576) + "MB",
        "Hit rate": Math.round(100 * this._getHitRate()) + "%",
        Entries: this._db.size.toString()
      },
          e = {},
          i = new Array();

      this._db.forEach(function (t, s) {
        var _h5 = t.lifetime;
        i[_h5] = (i[_h5] || 0) + t.size, _this._users.forAll(function (i) {
          var _h6 = i.namespace;

          if (s.startsWith(_h6)) {
            var _s = e[_h6] || 0;

            e[_h6] = _s + t.size;
          }
        });
      });

      var _h4 = {};

      this._users.forAll(function (t) {
        var s = t.namespace;

        if (!isNaN(t.hitRate) && t.hitRate > 0) {
          var _i2 = e[s] || 0;

          e[s] = _i2, _h4[s] = Math.round(100 * t.hitRate) + "%";
        } else _h4[s] = "0%";
      });

      var r = Object.keys(e);
      r.sort(function (t, s) {
        return e[s] - e[t];
      }), r.forEach(function (s) {
        return t[s] = Math.round(e[s] / Math.pow(2, 20)) + "MB / " + _h4[s];
      });

      for (var _ = i.length - 1; _ >= 0; --_) {
        var _e = i[_];
        _e && (t["Priority " + (_ + s - 1)] = Math.round(_e / this.size * 100) + "%");
      }

      return t;
    }
  }, {
    key: "resetStats",
    value: function resetStats() {
      this._hit = this._miss = 0, this._users.forAll(function (t) {
        return t.resetHitRate();
      });
    }
  }, {
    key: "clear",
    value: function clear(t) {
      var _this2 = this;

      this._db.forEach(function (e, s) {
        s.startsWith(t) && (_this2._size -= e.size, _this2._db.delete(s), _this2._notifyRemove(s, e.entry, 0));
      });
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      var _this3 = this;

      this._db.forEach(function (t, e) {
        return _this3._notifyRemove(e, t.entry, 0);
      }), this._size = 0, this._db.clear();
    }
  }, {
    key: "_getHitRate",
    value: function _getHitRate() {
      return this._hit / (this._hit + this._miss);
    }
  }, {
    key: "_notifyRemove",
    value: function _notifyRemove(t, e, s) {
      var i;
      return this._removeFuncs.some(function (_h7) {
        if (t.startsWith(_h7[0])) {
          var _t = _h7[1](e, s);

          return "number" == typeof _t && (i = _t), !0;
        }

        return !1;
      }), i;
    }
  }, {
    key: "_checkSizeLimit",
    value: function _checkSizeLimit() {
      if (!(this._size <= this._maxSize)) {
        var _iterator = _createForOfIteratorHelper(this._db),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
                _e2 = _step$value[0],
                _s2 = _step$value[1];

            if (this._db.delete(_e2), _s2.lives <= 1) {
              this._size -= _s2.size;

              var _i3 = this._notifyRemove(_e2, _s2.entry, 1);

              t(_i3) && _i3 > 0 && (this._size += _i3, _s2.lives = _s2.lifetime, _s2.size = _i3, this._db.set(_e2, _s2));
            } else --_s2.lives, this._db.set(_e2, _s2);

            if (this._size <= .9 * this.maxSize) return;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }]);

  return h;
}();

export { s as MIN_PRIORITY, i as MemCache, h as MemCacheStorage };